import apiClient from './client'

/**
 * Obtiene la lista de centros de trabajo
 */
export const getCentrosTrabajo = async () => {
  const response = await apiClient.get('/api/ObtenerCentrosTrabajo')

  // La respuesta tiene estructura: { code, payload, message }
  return response.data
}
